import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import { atfStatusInfo } from './abas/acompanhar/atfStatusInfo';
import type { HistoricoAtfResponse } from './abas/acompanhar/types';

/** Contagem de ATFs em andamento (PENDENTE/PROCESSANDO/INDETERMINADA) — badge da aba Acompanhar (handoff §0). */
export function useAtfEmAndamentoCount() {
  const [contagem, setContagem] = useState(0);

  useEffect(() => {
    api.get<HistoricoAtfResponse>('/cooperado/atf', { params: { limit: 30, offset: 0 } })
      .then(res => {
        const emAndamento = res.data.data.filter(i => {
          const info = atfStatusInfo(i.status, i.chPlc);
          return info.emAndamento || info.status === 'INDETERMINADA';
        });
        setContagem(emAndamento.length);
      })
      .catch(() => setContagem(0));
  }, []);

  return contagem;
}
